import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Discount } from "@edp-components/edp-pack-discount/edp-pack-discount.model";
import { PackService } from "@edp-services/pack.service";
import { PackSubscriberService } from "@edp-services/pack-subscriber.service";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { Contract } from "@edp-components/edp-contract/edp-contract.model";
import { EdpModalService } from "@edp-components/edp-modal";
import { Pack } from "@edp-components/edp-pack";

@Component({
    selector: "edp-pack-discount",
    templateUrl: "./edp-pack-discount.component.html",
    styleUrls: ["./edp-pack-discount.component.scss"],
})
export class EdpPackDiscountComponent implements OnInit, OnDestroy {
    @Input() discount: Discount;
    @Input() contract: Contract;
    @Input() isLast: boolean;

    public pack: Pack;
    private discountSubscription$: Subscription;
    public form: FormGroup;
    public isSelected = false;
    public isSubmited = false;
    public sameDiscount = false;
    public contractTypeLabel: string;

    constructor(
        private packService: PackService,
        private packSubscriberService: PackSubscriberService,
        private edpModalService: EdpModalService,
        private translate: TranslateService
    ) {
        this.discountSubscription$ = this.packService.discountChanged$.subscribe((discount: Discount) => {
            this.isSelected = discount.id === this.discount.id && !discount.current;
        });

    }

    ngOnInit() {
        this.pack = this.packSubscriberService.getPack();
        const dualLabel = this.translate.instant("pt.edp.edponline.pack.discount.both");
        const electricityLabel = this.translate.instant("pt.edp.edponline.pack.discount.electricity");
        const gasLabel = this.translate.instant("pt.edp.edponline.pack.discount.gas");

        this.sameDiscount = this.discount.values.gas === this.discount.values.electricity;
        this.contractTypeLabel =
            this.discount.contractType === "dual"
                ? dualLabel
                : (this.discount.contractType === "electricity" ? electricityLabel : gasLabel);
        setTimeout(() => {
            if (this.discount.isChecked) {
                this.checked(false);
            }
            if (this.discount.current) {
                this.packService.setDiscount(this.discount);
            }
        });
    }

    ngOnDestroy(): void {
        this.discountSubscription$.unsubscribe();
    }

    public checked(dispatchEvent: boolean): void {
        if (!this.discount.current) {
            const contaCerta: number = this.packSubscriberService.getContaCerta();
            const hasDirectDebit = this.discount.form ? JSON.parse(this.discount.form).hasDirectDebit : false;
            const showModal: boolean = dispatchEvent && contaCerta > 0 && !hasDirectDebit;
            this.packSubscriberService.dispatchSubmitIntention(false);

            if (showModal) {
                this.edpModalService
                    .confirm({
                        title: this.translate.instant("pt.edponline.conta-certa.unsubscribe-title"),
                        message: this.translate.instant("pt.edponline.conta-certa.unsubscribe-message"),
                        showClose: true,
                        dismissButton: this.translate.instant("pt.edp.edponline.common.no"),
                        confirmButton: this.translate.instant("pt.edp.edponline.common.yes"),
                    })
                    .then(() => {
                        this.packService.setDiscount(this.discount);
                        this.packSubscriberService.setContaCerta(0);
                        this.packService.contacertaChanged$.next(0);
                    })
                    .catch(() => { /* Intentionally silent */ });
                return;
            }
            this.packService.setDiscount(this.discount);
        }
    }
}
